import { Component, Vue, Prop } from 'vue-property-decorator';

@Component<Pill>({})
export default class Pill extends Vue {
  @Prop({ default: '' })
  protected label!: string;

  @Prop({ default: '' })
  protected status!: string;
}
